<template>
	<div class="login-reep">
		<!--移动端特殊处理样式start-->
		<div class="mobile-help">
			<div class="logo-header">
				<span v-if="brandData?.favicon" class="logo-text">
					<el-image
						style="max-width: 40px; vertical-align: middle"
						:src="brandData.favicon"
						fit="cover"
					/>
				</span>
				<span v-else class="logo-text-default">{{ spliceText(brandData?.brand_name) }}</span>
				<span class="name">{{ brandData.brand_name }}</span>
			</div>
			<div class="help">
				<a
					v-if="brandData.is_help"
					target="_blank"
					href="https://oemsaas.yuque.com/staff-sbl3ig/clazyz"
				>
					{{ $t('login.help_center') }}
				</a>
				<RouterLink target="_blank" to="/terms">{{ $t('login.terms_service') }}</RouterLink>
			</div>
		</div>
		<!--移动端特殊处理样式end-->
		<div class="login-container">
			<div class="login-banner" ref="logoBg">
				<div class="logo"></div>
				<div class="copyright">
					<h2>{{ brandData.slogan }}</h2>
					<p>{{ brandData.copyright }}</p>
				</div>
			</div>
			<div class="login-form">
				<div class="login-content">
					<div class="header" :class="{ border: isTop }">
						<div class="logo-header">
							<span v-if="brandData?.favicon" class="logo-text">
								<el-image
									style="max-width: 40px; vertical-align: middle"
									:src="brandData.favicon"
									fit="cover"
								/>
							</span>
							<span v-else class="logo-text-default">{{ spliceText(brandData?.brand_name) }}</span>
							<span class="name">{{ brandData.brand_name }}</span>
						</div>
						<div class="help">
							<a
								target="_blank"
								v-if="brandData.is_help"
								href="https://oemsaas.yuque.com/staff-sbl3ig/clazyz"
							>
								{{ $t('login.help_center') }}
							</a>
							<RouterLink target="_blank" to="/terms">{{ $t('login.terms_service') }}</RouterLink>
						</div>
					</div>
					<div class="login-swich" ref="login_swich">
						<div class="reep" :class="{ max_height: isTop }" ref="tab">
							<el-tabs v-model="logoType" v-show="logoType !== 'forget'" @tab-click="tabChange">
								<el-tab-pane :label="$t('login.login')" name="login">
									<Account @change="changeType" />
								</el-tab-pane>
								<el-tab-pane :label="$t('login.reg')" name="register" v-if="!isHW()">
									<Register />
								</el-tab-pane>
							</el-tabs>
							<ForgetPassword v-if="logoType === 'forget'" @change="changeType" />
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script lang="ts" setup>
import { onMounted, ref, nextTick, provide, watchEffect, PropType } from 'vue'
import type { BrandDate } from '@/api/types/common'
import Account from '../Account.vue'
import ForgetPassword from '../ForgetPassword.vue'
import Register from '../Register.vue'
import { useRoute } from 'vue-router'
import { getScreenType, isHW } from '@/utils'

export type LogoType = 'login' | 'forget' | 'register'

const props = defineProps({
	data: {
		type: Object as PropType<BrandDate>,
		default: () => {
			return {}
		},
	},
})
//获取品牌数据
const brandData = ref(props.data)
const logoBg = ref()
watchEffect(() => {
	brandData.value = props.data
	nextTick(() => {
		logoBg.value.style.backgroundImage = `url(${props.data.url3})`
	})
})

const { query } = useRoute()
const invite_code = query.params ? JSON.parse(query.params as any)?.invite_code : ''

const logoType = ref<LogoType>(invite_code ? 'register' : 'login')

const changeType = (val) => {
	logoType.value = val
}

provide('logoType', logoType)

//匹配如果是第三方跳过来为注册页则需要设置为注册页
const matchingRg = () => {
	if (query.redirect && (query.redirect as string).indexOf('register') !== -1) {
		logoType.value = 'register'
		//window.location.href = window.location.href.replaceAll('/register.html', '/')
		history.replaceState(null, '', '/')
	}
}
const spliceText = (item) => {
	if (item) {
		return item.slice(0, 1)
	}
}

const tab = ref() //tab  dom
const login_swich = ref()
const isTop = ref(false) //header dom
const tabChange = () => {
	nextTick(() => {
		const offTop = 100 //顶部距离这个其实就是顶部logo的高
		const tabTop = tab.value.offsetTop
		const swichHeight = login_swich.value.offsetHeight
		if (tabTop < offTop && getScreenType().IS_PC) {
			isTop.value = true
			tab.value.style.maxHeight = swichHeight + 'px'
		} else {
			isTop.value = false
			tab.value.style.maxHeight = 'none'
		}
	})
}
onMounted(() => {
	matchingRg()
})
</script>

<style scoped lang="scss">
@import '@/theme/media/index.scss';
@import '../../static/login_extend.scss'; //继承样式
.login-reep {
	height: 100%;

	.mobile-help {
		display: none;
		@media screen and (max-width: $sm) {
			@include extendHeader;

			padding: 15px;
			margin-top: 0;
			background-color: #fff;

			> div {
				flex: 1;
			}

			.logo-header {
				margin-top: 0;

				.name {
					font-size: 15px;
				}
			}

			.help {
				flex: 0 0 170px;
				text-align: right;
			}
		}
	}

	.login-container {
		display: flex;
		width: 100%;
		min-height: 100vh;
		@media screen and (max-width: $sm) {
			position: relative;
			display: block;
			min-height: calc(100% - 70px);
		}

		.login-banner {
			position: relative;
			flex: 0 0 45%;
			background-color: #8b9bc5;
			background-repeat: no-repeat;
			background-size: cover;
			@media screen and (max-width: $sm) {
				height: calc(100vh - 70px);
			}

			.logo {
				position: absolute;
				top: 5%;
				left: 5%;
				max-width: 160px;
				font-size: 16px;
				font-weight: 700;
				color: #fff;

				.logo-flex {
					display: flex;
					align-items: center;
					justify-content: center;
				}

				.el-image {
					width: auto !important;

					:deep(img) {
						max-height: 36px;
					}
				}

				.logo-text {
					padding-left: 8px;
				}
			}
		}

		.login-form {
			flex: 0 0 55%;
			background-color: #fff;
			@media screen and (max-width: $sm) {
				position: absolute;
				top: 50%;
				left: 50%;
				border-radius: var(--border-radius);
				transform: translate(-50%, -50%);
			}

			.login-content {
				width: 100%;

				.header {
					@include extendHeader;

					padding: 0 40px;
					@media screen and (max-width: $sm) {
						display: none;
					}
				}

				.border {
					padding-bottom: 30px;
					border-bottom: 1px solid #eee;
				}

				.login-swich {
					display: flex;
					align-items: center;
					justify-content: center;
					height: 80vh;
					@media screen and (max-width: $sm) {
						align-items: flex-start;
						height: auto;
						padding: 15px;
						padding-top: 0;
					}

					.reep {
						width: 400px;
						@media screen and (max-width: $sm) {
							width: 300px;
						}

						:deep(.el-tabs .el-tabs__nav-wrap) {
							padding-left: 0;
						}

						:deep(.el-tabs .el-tabs__nav-wrap .el-tabs__item) {
							height: 30px;
							font-size: 16px;
							font-weight: bold;
							line-height: 30px;
						}

						:deep(.el-tabs__nav-wrap) {
							&::after {
								content: none;
							}
						}
					}

					.max_height {
						position: absolute;
						top: 120px;
						overflow: auto;
					}
				}
			}
		}

		.copyright {
			position: absolute;
			bottom: 5%;
			left: 5%;
			color: #fff;
			@media screen and (max-width: $sm) {
				left: 0;
				width: 100%;
				text-align: center;
			}

			h2 {
				font-size: 28px;
				font-weight: 700;
			}

			p {
				font-size: 12px;
				opacity: 0.5;
			}
		}
	}
}
</style>
